<template>
  <div class="card-problem">
    <div class="card-problem-row" v-for="item in data" :key="item" @click="onClick(item)">
      <div class="problem-left">
        <img src="../../../../assets/ai/ai_greet.png" alt="">
      </div>
      <div class="problem-content">{{item}}</div>
      <div class="problem-right">
        <img src="../../../../assets/ai/ai_right.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      data: {
        type: Array,
        default: () => []
      }
    },
    methods: {
      onClick(problem) {
        this.$emit('card-problem', problem)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .card-problem {
    margin-top: 16px;
  }
  .card-problem-row {
    width: 100%;
    display: flex;
    align-items: center;
    background: linear-gradient( 270deg, #737EFF 0%, #9F8DFC 100%);
    box-shadow: 0px 2px 4px 0px rgba(7, 41, 177, 0.05);
    border-radius: calc(25px / 2);
    padding: 6px 8px;
    padding-right: 14px;
    box-sizing: border-box;
    margin-top: 6px;
    min-height: calc(76px / 2);
    cursor: pointer;
    &:hover {
      opacity: 0.9;
    }
    .problem-left {
      width: 20px;
      height: 20px;
      background: linear-gradient( 270deg, #73E3FF 0%, #998DFC 100%);
      box-shadow: 0px 2px 4px 0px rgba(7, 41, 177, 0.05);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        display: block;
        width: 12px;
      }
    }
    .problem-content {
      flex: 1;
      font-size: 14px;
      color: #ffffff;
      font-weight: bold;
      padding: 0 8px;
      line-height: 1.4;
    }
    .problem-right {
      width: 12px;
      height: 15px;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        height: 100%;
        object-fit: contain;
      }
    }
  }
</style>